import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ICapitalRequest,
  ICapitalListResponse,
  ICapitalBaseDetailsResponse,
} from '../../interfaces/fund-details/capital-base';
import { API_ENDPOINTS } from '../../utils/api-endpoints.const';
import { ApiResponse } from '../../interfaces/shared/fund/api-response';

@Injectable({
  providedIn: 'root',
})
export class CapitalService {
  private readonly http = inject(HttpClient);

  createCapital(
    fundUuid: string,
    data: ICapitalRequest
  ): Observable<ApiResponse<unknown>> {
    return this.http.post<ApiResponse<unknown>>(
      API_ENDPOINTS.CAPITAL_BASES(fundUuid),
      data
    );
  }

  getCapitalBases(
    fundUuid: string,
    page: number,
    perPage: number
  ): Observable<ICapitalListResponse> {
    const params = { page: page, per_page: perPage };

    return this.http.get<ICapitalListResponse>(
      API_ENDPOINTS.CAPITAL_BASES(fundUuid),
      { params }
    );
  }

  getCapitalBaseDetails(
    fundUuid: string,
    capitalBaseUuid: string
  ): Observable<ICapitalBaseDetailsResponse> {
    return this.http.get<ICapitalBaseDetailsResponse>(
      API_ENDPOINTS.CAPITAL_BASE_DETAILS(fundUuid, capitalBaseUuid)
    );
  }

  updateCapital(
    fundUuid: string,
    capitalBaseUuid: string,
    data: ICapitalRequest
  ): Observable<ApiResponse<unknown>> {
    return this.http.post<ApiResponse<unknown>>(
      API_ENDPOINTS.CAPITAL_BASE_DETAILS(fundUuid, capitalBaseUuid),
      data
    );
  }
}
